// extracted by mini-css-extract-plugin
export default {"container":"container-eoqvX","label":"label-iLwQH","appearance":"appearance-diNX5"};